import { cn } from '@/lib/utils'

export default function TruncateText({
  text,
  maxWidth,
  className,
}: {
  text: string
  maxWidth?: string
  className?: string
}) {
  return (
    <div
      className={cn('truncate', className)}
      style={{ maxWidth: maxWidth ?? '240px' }}
      title={text}
    >
      {text}
    </div>
  )
}
